import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CONST_AWS_API, DEFAULT_IMAGE, API as API_KEYS } from 'src/app/core/constants';
import { API as AWS_API } from "aws-amplify";
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { UserService } from 'src/app/core/services/user.service';
import { filter, observable, Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { AppService } from 'src/app/core/services/app.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { StorageService } from '../../../../core/services/storage.service';
// import { ThrowStmt } from '@angular/compiler';
import { ToastrService } from 'ngx-toastr';
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { UtilityService } from 'src/app/core/services/utility.service';
import { groupTeamsByNetwork, filterTeamGroups, GroupedTeams } from 'src/app/core/utils/team-grouping.util';
declare let $: any;
@Component({
  selector: 'app-network-merchandise',
  templateUrl: './network-merchandise.component.html',
  styleUrls: ['./network-merchandise.component.scss']
})
export class NetworkMerchandiseComponent implements OnInit {
  public isBlue = false;
  colors: boolean[];

  sortBy: any = [{ name: 'Recently Added', value: { 'field': 'date_added', 'order': 'desc' } }, { name: 'Most Viewed', value: { 'field': 'views', 'order': 'desc' } },];
  getCurrency: any;
  currenciesList: any = [];
  currency: any;
  organizationId: any;
  getCurrencyType: any;
  currencyInfoSubscription: Subscription;
  currentLocation:any = {};
  stockData = { "name": 'stock', value: 1, "organization_id": null, "network_group_id": 0}
  channelName: string;
    currencyJSON: any = [];


  categoryList: any = []
  brandProductsList = [];
  // Raw org-filtered results straight from marketSearch, before the Group/Home/Away
  // Team/Athlete filters below narrow it into brandProductsList - client-side only, no API
  // call, so selecting/clearing these filters doesn't re-query the server.
  fullProductsList: any[] = [];
  overallFilter: any = []
  allOrgFeatures: any[];
  merchandiseOrganizations: any[];
  settingsData: any = {};
  settingsDataSubscription: Subscription;
  groups:any;
  groupsLabel = 'Group';
  performerInfoSubscription!: Subscription;
  org_id: any;
  private recommendationsPosted = false;

  // Group/Home Team/Away Team/Athlete filters - no date range, sport, or division here (those
  // concepts don't exist on merchandise products), mirroring event-marketplace's filter-card
  // pattern via the same shared FilterDropdownComponent.
  teamsList: any[] = [];
  athleteList: any[] = [];
  teamsNetworkLabel = '';
  homeGroupGroups: GroupedTeams = { networkLabel: '', networkTeams: [], groupedTeams: [] };
  awayGroupGroups: GroupedTeams = { networkLabel: '', networkTeams: [], groupedTeams: [] };
  homeTeamSearchText = '';
  awayTeamSearchText = '';
  athleteSearchText = '';

  selectedGroup: any = null;
  selectedGroupName = '';
  selectedHomeTeam: any = null;
  selectedHomeTeamName = '';
  selectedAwayTeam: any = null;
  selectedAwayTeamName = '';
  selectedAthlete: any = null;
  selectedAthleteName = '';

  groupDisplayFn = (g: any) => g?.group_name || g?.name || '';
  teamDisplayFn = (t: any) => t?.name || '';
  athleteDisplayFn = (a: any) => a?.personalInfo ? `${a.personalInfo.firstName || ''} ${a.personalInfo.lastName || ''}`.trim() : (a?.name || '');

  get filteredAthleteList() {
    if (!this.athleteSearchText) return this.athleteList;
    const searchText = this.athleteSearchText.toLowerCase();
    return (this.athleteList || []).filter((a: any) => this.athleteDisplayFn(a).toLowerCase().includes(searchText));
  }

  constructor(private router: Router, private userService: UserService, private commanService: CommanSubscribeService, private appService: AppService, private ngxLoader: NgxUiLoaderService, public toaster: ToastrService, private storageService: StorageService, private utilityService: UtilityService, private route: ActivatedRoute) { }

  async ngOnInit() {
    this.settingsDataSubscription = this.commanService.getICWebpageThemeSettings().subscribe(async (response) => {
      this.settingsData = response;
    });
    this.settingsData = this.commanService.icWebpageSettingsData;
    this.storageService.deleteItem("product_info");
    $('#DD').on('hide.bs.dropdown', function (e) {
      if (e.clickEvent) {
        e.preventDefault();
      }
    })
    this.allOrgFeatures = await this.utilityService.loadAllOrganizationFeaturesByFeature("merchandise");
    this.merchandiseOrganizations = this.allOrgFeatures
  .filter((org: any) => org.dataStatus === "A")
  .map((org: any) => org.orgId);
  console.log("this.merchandiseOrganizations",this.merchandiseOrganizations);
    let locInfo = this.commanService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commanService.getCurrentLocation((val: any, json: any) => {
        console.log(json);
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
        }
        this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
        console.log('thi.getcurrency', this.getCurrency)
      });
    } else if(this.currentLocation && Object.keys(this.currentLocation).length > 0){
      this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
    }
    this.currencyInfoSubscription = this.commanService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
        console.log('thi.getcurrency', this.getCurrency)
        // this.getFilterData('loadpage');
        // this.getSubscriptionList();
      }
    });
    this.getCurrency = this.getCurrency ? this.getCurrency : this.storageService.getItem('currency');
    this.channelName = this.route.parent.snapshot.params['channelName'];
    console.log("channelName:", this.channelName);

    this.commanService.getCurrenciesJSON().subscribe((result) => {
      Object.keys(result).forEach((element) => {
        let value = element + " - " + result[element];
        this.currencyJSON.push({ currency: value });
        this.currenciesList.push(value);
      });
    });
    this.getCurrency = this.storageService.getItem("currency");
    this.currentLocation =
      locInfo && Object.keys(locInfo).length > 0
        ? locInfo
        : this.storageService.getItem("current_location");
    if (
      !this.currentLocation ||
      Object.keys(this.currentLocation).length == 0
    ) {
      this.commanService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
        }
        if (
          this.currentLocation &&
          this.currentLocation.currency &&
          (Object.keys(this.route.snapshot.queryParams).length == 0 ||
            (Object.keys(this.route.snapshot.queryParams).length > 0 &&
              !this.route.snapshot.queryParams.currency))
        ) {
          setTimeout(() => {
            this.setCurrency();
          }, 1000);
        }
      });
    } else if (
      this.currentLocation &&
      Object.keys(this.currentLocation).length > 0
    ) {
      setTimeout(() => {
        this.setCurrency();
      }, 1000);
    } else {
      setTimeout(() => {
        this.setCurrency();
      }, 1000);
    }

    this.performerInfoSubscription = this.commanService.getPerfomerInfo().subscribe(response => {
      this.getPerformerSubscriptionInfo(response);
    });
    this.getPerformerDetails();
  }

  getPerformerSubscriptionInfo(response: any) {
    if (response && response.data && response.data.statusCode === '200') {
      this.org_id = response.data.Data?.[0]?.organization_id ?? null;
      // this.postRecommandations();
    }
  }

  postRecommandations() {
    if (this.recommendationsPosted) return;
    this.recommendationsPosted = true;
    if (this.router.url.includes('/preview')) return;
    if (!this.org_id) {
      console.warn(
        '[Merchandise][Recommendations] Missing required data:',
        { orgId: this.org_id }
      );
      return;
    }
    try {
      let formData = new FormData();
      formData.append('user_id', this.userInfo.id.toString());
      formData.append('organization_id', this.org_id.toString());
      formData.append('recommendation_type', 'products');
      formData.append('top_k', '40');
      if (this.commanService.activeGroupId) {
        formData.append('network_group_id', this.commanService.activeGroupId.toString());
      }
      const url = `${API_KEYS.AI_RECOMMENDATION}?NOLOADER`;
      this.appService.postBaseRequest(url, formData).subscribe(result => {
        if (result.statusCode === 200) {
          console.log("collection marketplace recommendation success", result)
        }
      }, error => {
        console.log("collection marketplace recommendation error", error)
        console.log(error);
      })
    } catch (error) {
      console.log("collection marketplace recommendation error", error)
    }
  }

  getProduct(id,orgId,brand) {
    (window as any).umami?.track(`Collection ${id} clicked`);
    const u_payload = {
      actionType: "marketplace",
      metaData: {
        title: `Collection ${id} clicked`,
        collectionId: id,
        orgId: orgId,
        timeStamp: new Date().toISOString()
      },
      organizationId: orgId || null,
      clickAction: `marketplace`,
      networkGroupId: brand._source.network_group_id || 0
    }
    this.commanService.sendTriggeredEvent(u_payload);
    const itemGroup = brand._source.network_group_id
        ? this.groups.find((g: any) => g.id === brand._source.network_group_id)
        : null;
    
    const groupSlug = itemGroup ? itemGroup.group_slug : '';
    this.router.navigate(['/' + this.channelName + (groupSlug ? '/' + groupSlug : '') + '/merchandise/product-marketplace/' + id]);

  }
  // API call to get collections from start ->stating to limt -> to get no of data from response
  userInfo: any;
  start = 0;
  found = 0;
  price: any = []
  getOverallFilter(response) {
    console.log(response, "getcategorylistdata1")
    this.overallFilter = [];
    if (response.data?.aggregations) {
      Object.entries(response.data?.aggregations).forEach((data: any) => {
        let newdata = { 'name': '', 'value': {} }
        if (data[0] == "network" && data[1].buckets.length > 0) {
          data[1].buckets.forEach(el => {
            if (this.filterArray.length > 0) {
              this.filterArray.forEach(element => {
                if (element.name == data[0] && element.value) {
                  el.fillter = true;
                }
              });
            }
            else {
              el.fillter = false;
            }
          });
          newdata.name = data[0];
          newdata.value = data[1];
          this.overallFilter.push(newdata);
        }
        else if (data[0] == "discount" && data[1].buckets.length > 0) {
          data[1].buckets.forEach(el => {
            if (this.filterArray.length > 0) {
              this.filterArray.forEach(element => {
                if (element.name == data[0] && element.value) {
                  el.fillter = true;
                }
              });
            }
            else {
              el.fillter = false;
            }
          });
          newdata.name = data[0];
          newdata.value = data[1];
          this.overallFilter.push(newdata);
        }
        else if (data[0] == "price" && data[1].buckets.values.length > 0) {
          this.price = []
          data[1].buckets.values.forEach(el => {
            console.log(el, el.value, "price")
            this.price.push(el)
          });
          newdata.name = data[0];
          newdata.value = data[1];
          this.mininput = Math.min.apply(null, this.price) == 0 ? 1 : Math.min.apply(null, this.price);
          this.maxinput = Math.max.apply(null, this.price) == 0 ? 1 : Math.max.apply(null, this.price);
          // this.priceValues();
          // this.overallFilter.push(newdata);
        }
      });
    }

    // console.log(this.filterArray, 'filter', this.price, "Price", Math.max.apply(null, this.price), Math.min.apply(null, this.price))
  }
  //  get data when Scrolled  to bottom
  entredapi: boolean = false;
  onScrollDown() {
    this.entredapi = true;
    // you're at the bottom of the page
    console.log(this.found, this.brandProductsList.length)
    if (this.found != this.brandProductsList.length) {
      this.start += 8;
      this.ngxLoader.start()
      this.getFilterData("getnext");
    }
    else {
      this.ngxLoader.stop();
      this.entredapi = false;
      // this.toaster.success("End of Data");
    }
  }
  scrollheader(data) {
    let scrol = document.getElementById('categoryBtns');
    if (data == 'left') {
      scrol.scrollLeft = scrol.scrollLeft - (scrol.offsetWidth / 2);
    }
    else {
      scrol.scrollLeft = scrol.scrollLeft + (scrol.offsetWidth / 2);
    }
  }

  CollectionFilter = []
  filterArray: any = [];
  dumArray: any = []

  getFilter(colleciton, from?, parentCollection?) {
    
    if (from == "category") {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Category ${colleciton.value} Clicked - ${userId}`)
      const data = {
        actionType: "product",
        metaData: {
          title: `Category "${colleciton.value}" Clicked`,
          timeStamp: new Date().toISOString()
          
        },
        organizationId: this.organizationId || null,
        clickAction: `product`
      }
      this.commanService.sendTriggeredEvent(data);
      // this.CollectionFilter = [];
      this.filterArray = [];
      this.dumArray = [];
      this.range = {};
      this.mininput = '';
      this.maxinput = '';
      this.selectedDiscount = '';
      this.overallFilter.forEach(fil => {
        fil.value.buckets.forEach(fildata => {
          fildata.fillter = false;
        });
      })
      this.overallFilter = [];
      this.query = '';
      // this.sortData = {};
      if (this.categoryList.length > 0) {
        this.categoryList.forEach(c => {
          let newda = (this.CollectionFilter.filter(n => n.value == colleciton.value).length);
          if (c.value == colleciton.value && newda == 0) {
            c.fillter = true;
            this.CollectionFilter.push(c);
          }
          else if (c.value == colleciton.value && newda > 0) {
            c.fillter = false;
            this.CollectionFilter = this.CollectionFilter.filter(n => n.value != colleciton.value);
          }
        })
      }
      console.log(this.CollectionFilter, "getcategorylistdata>>>>")
      console.log(this.categoryList, "getcategorylistdata>>>>")
      this.getFilterData(from);
    }
    if (from == 'filter') {
      if (this.overallFilter.length > 0) {
        // this.dumArray = []
        this.overallFilter.forEach(fil => {
          if (fil.name == parentCollection) {
            fil.value.buckets.forEach(fildata => {
              if (fildata.value == colleciton.value && !fildata.fillter) {
                fildata.fillter = true;
                let ndata = this.dumArray.filter(ar => ar.value == colleciton.value)
                if (ndata.length == 0) {
                  this.dumArray.push({ 'name': parentCollection, 'value': colleciton.value });
                }
              }
              else {
                fildata.fillter = false;
              }
            });
          }
        })
      }
      this.applyfilter();
    }
  }
  
  query: any = '';
  netClear: boolean = false;
  priceClear: boolean = false;
  disClear: boolean = false;
  // Calling api for fillter data or cliing collection;
  getFilterData(from?) {
    this.ngxLoader.start()
    this.userInfo = this.commanService.userInfo;
    
    let filterData = [];
    if (from != 'getnext') {
      this.start = 0;
    }
    filterData = this.getFilterSearch();

    // filterData.push({ "name": 'network', "value": 'Nandu' })
    let url = "marketSearch";
    this.range = {};
    let body = {
      "type": "collection",
      "filters": filterData,
      'q': this.query,
      start: this.start,
      "sort": this.sortData,
      // "range": {},
      "currency": this.getCurrency ? this.getCurrency : this.storageService.getItem('currency'),
      limit: 16
    }
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: body
    }
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(res => {
      let response:any = {};
      response.data = res.data.body;
      if (response.data.hits.hits) {
        this.ngxLoader.stop();
        if (this.sortName.length == 0) {
          this.sortbyfilter({ 'field': 'date_added', 'order': 'desc' }, 'Recently Added');
        }
        if (from == 'loadpage') {
          this.categoryList = response.data.aggregations.category.buckets.map(bucket => ({...bucket, value: bucket.key}));
        }
        this.found = response.data.hits.total?.value;
        if (from != 'getnext') {
          this.fullProductsList = response.data.hits.hits || [];
        }
        else {
          response.data.hits.hits.forEach(element => {
            this.fullProductsList.push(element)
          });
        }
        // this.disountFun(response);
        this.fullProductsList = this.fullProductsList.filter((brand: any) => this.merchandiseOrganizations.includes(Number(brand._source.organization_id)));
        this.applyTeamAthleteFilters();
        this.getOverallFilter(response);
        // this.priceClear = body.range && body.range.length > 0 ? true : false;
        let netfill = filterData.filter(a => a.name == 'network');
        let Disfill = filterData.filter(a => a.name == 'discount');
        this.netClear = netfill && netfill.length > 0 ? true : false;
        this.disClear = Disfill && Disfill.length > 0 ? true : false;
        this.overallFilter.forEach(element => {
          if (element.name == "network") {
            element.showfilter = this.netClear;
          }
          else if (element.name == "discount") {
            element.showfilter = this.disClear;
          }
        });
        console.log(this.overallFilter, "overAllfilter1")
        this.ngxLoader.stop();
      }

      this.entredapi = false;
    }).catch(error => {
    });


  }

  setCurrency() {
    let cur =
      Object.keys(this.route.snapshot.queryParams).length > 0 &&
        this.route.snapshot.queryParams.currency
        ? this.route.snapshot.queryParams.currency
        : this.getCurrency;
    this.currenciesList.forEach((element) => {
      let getVal = element.split(" -");
      let code = cur
        ? cur
        : this.currentLocation.currency &&
          this.currentLocation.currency.code.includes('"')
          ? JSON.parse(this.currentLocation.currency.code)
          : this.currentLocation.currency.code;
      if (getVal[0] == code) {
        this.currency = element;
        this.storageService.setItem("currency", getVal[0]);
        this.commanService.sendCurrencyInfo(getVal[0]);
      }
    });
  }
  changeCurrency(event) {
    let getVal = event.split(" -");
    this.currency = event;
    this.storageService.setItem("currency", getVal[0]);
    this.commanService.sendCurrencyInfo(getVal[0]);
  }

  getPerformerDetails() {
    this.userInfo = this.commanService.userInfo;
    this.getCurrency = this.storageService.getItem("currency");
    let code =
      this.currentLocation && this.currentLocation.currency
        ? this.currentLocation.currency.code
        : "";
    let currentCode = code.includes('"') ? JSON.parse(code) : code;
    let localCurrency =
      this.getCurrency && this.getCurrency.includes('"')
        ? JSON.parse(this.getCurrency)
        : this.getCurrency;
    let channel_name = this.router.url.split("/")[1];
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
      },
      response: true,
      body: {
        channel_name: channel_name,
        currency: localCurrency ? localCurrency : currentCode,
        user_id: this.userInfo.id,
      },
    };
    this.ngxLoader.start();
    console.log("Data  : ", data)
    AWS_API.post(
      environment.AWS_Cognito.apiName,
      CONST_AWS_API.GET_PERFORMER_INFO,
      data
    ).then(async (response) => {
      const channelName = response?.data?.Data?.[0]?.channel_display_name;
      //this.titleService.setTitle(response.data.Data[0].channel_display_name);
      this.groups = response.data?.Data[0]?.groups;
      this.groupsLabel = response.data?.Data[0]?.network_type_label || 'Group';
      const _segment2 = this.router.url.split('/')[2];
      const groupSlug = _segment2 && !['event', 'channel', 'stream', 'watch', 'album', 'subscription-list'].includes(_segment2) ? _segment2 : '';
      console.log('Extracted groupSlug:', groupSlug);
      const itemGroup = groupSlug
        ? this.groups?.find((g: any) => g.group_slug === groupSlug)
        : null;
      this.organizationId = response?.data?.Data?.[0]?.organization_id;
      this.stockData.organization_id = this.organizationId;
      this.stockData.network_group_id = itemGroup?.id || 0;
      this.teamsNetworkLabel = channelName || '';
      this.getTeamsList();
      this.getAthleteList();
      this.ngxLoader.stop();
      if (response.data.statusCode === "200") {
        console.log("performer response", response);
        this.commanService.sendPerfomerInfo(response);
        
      }
      this.getFilterData("loadpage");
    });
  }

  // Home/Away Team options are sourced from the teams API (league/team/all), same as
  // event-marketplace's getTeamsList() - not filtered by selectedGroup, matching that page's
  // Group/Team decoupling.
  getTeamsList() {
    if (!this.organizationId) return;
    this.appService.postBaseRequest(API_KEYS.GET_TEAMS, { organizationId: this.organizationId }).subscribe((result: any) => {
      this.teamsList = ((result && result.data) || []).filter((team: any) => team.dataStatus === 'A');
      this.refreshHomeGroupGroups(this.selectedAwayTeam);
      this.refreshAwayGroupGroups(this.selectedHomeTeam);
    }, (error) => {
      console.error('Error loading teams:', error);
      this.teamsList = [];
    });
  }

  // Excludes the other side's current selection so the same team can't be picked as both Home
  // and Away - same pattern as event-marketplace.component.ts's refreshHomeGroupGroups/
  // refreshAwayGroupGroups/isExcludedTeam/isSameTeamId.
  refreshHomeGroupGroups(excludeTeamId?: any) {
    const teams = (this.teamsList || []).filter((t: any) => !this.isExcludedTeam(t, excludeTeamId));
    const grouped = groupTeamsByNetwork(teams, this.groups || [], this.teamsNetworkLabel);
    this.homeGroupGroups = filterTeamGroups(grouped, this.homeTeamSearchText);
  }

  refreshAwayGroupGroups(excludeTeamId?: any) {
    const teams = (this.teamsList || []).filter((t: any) => !this.isExcludedTeam(t, excludeTeamId));
    const grouped = groupTeamsByNetwork(teams, this.groups || [], this.teamsNetworkLabel);
    this.awayGroupGroups = filterTeamGroups(grouped, this.awayTeamSearchText);
  }

  private isExcludedTeam(candidate: any, excludedId: any): boolean {
    if (excludedId === null || excludedId === undefined || excludedId === '') return false;
    if (this.isSameTeamId(candidate.id, excludedId)) return true;
    const excluded = (this.teamsList || []).find((t: any) => this.isSameTeamId(t.id, excludedId));
    return !!excluded && !!candidate.name && !!excluded.name
      && candidate.name.trim().toLowerCase() === excluded.name.trim().toLowerCase();
  }

  private isSameTeamId(a: any, b: any): boolean {
    if (a === null || a === undefined || b === null || b === undefined) return false;
    return String(a) === String(b);
  }

  onHomeTeamSearchTextChange(value: string) {
    this.homeTeamSearchText = value;
    this.refreshHomeGroupGroups(this.selectedAwayTeam);
  }

  onAwayTeamSearchTextChange(value: string) {
    this.awayTeamSearchText = value;
    this.refreshAwayGroupGroups(this.selectedHomeTeam);
  }

  onAthleteSearchTextChange(value: string) {
    this.athleteSearchText = value;
  }

  // Same payload shape as community-maincontent.component.ts's confirmed-working getAtheletsData().
  getAthleteList() {
    if (!this.organizationId) return;
    this.appService.postBaseRequest(API_KEYS.GET_ATHLETS_DATA, { organizationId: this.organizationId, search: '', dataStatus: 'A', networkGroupId: null }).subscribe((result: any) => {
      this.athleteList = (result && result.data) || [];
    }, (error) => {
      console.error('Error loading athletes:', error);
      this.athleteList = [];
    });
  }

  // Group is already implied by the URL when browsing a group-scoped page, so the Group
  // filter card is redundant and hidden - same pattern as event-marketplace's isGroupScoped.
  // Not defaulted into selectedGroup here: network-merchandise already scopes results to the
  // active group server-side (network_group_id is appended straight from activeGroupId in the
  // marketSearch request body), so there's nothing left for the client-side filter to narrow.
  get isGroupScoped(): boolean {
    return !!this.commanService.activeGroupId;
  }

  selectGroup(group: any) {
    this.selectedGroup = group ? group.id : null;
    this.selectedGroupName = group ? (group.group_name || group.name) : '';
    this.applyTeamAthleteFilters();
  }

  selectHomeTeam(team: any) {
    this.selectedHomeTeam = team ? team.id : null;
    this.selectedHomeTeamName = team ? team.name : '';
    this.homeTeamSearchText = '';
    this.refreshAwayGroupGroups(this.selectedHomeTeam);
    this.applyTeamAthleteFilters();
  }

  selectAwayTeam(team: any) {
    this.selectedAwayTeam = team ? team.id : null;
    this.selectedAwayTeamName = team ? team.name : '';
    this.awayTeamSearchText = '';
    this.refreshHomeGroupGroups(this.selectedAwayTeam);
    this.applyTeamAthleteFilters();
  }

  selectAthlete(athlete: any) {
    this.selectedAthlete = athlete ? athlete.id : null;
    this.selectedAthleteName = athlete ? this.athleteDisplayFn(athlete) : '';
    this.athleteSearchText = '';
    this.applyTeamAthleteFilters();
  }

  // Client-side only - narrows the already-fetched fullProductsList into brandProductsList,
  // no marketSearch call. Filters against each product's _source fields (indexed by the
  // consumer-service sync job, same fields network_group_id/home_team_id/away_team_id/
  // athlete_id already used elsewhere in this file for network_group_id).
  applyTeamAthleteFilters() {
    let list = this.fullProductsList || [];
    if (this.selectedGroup) {
      list = list.filter((brand: any) => Number(brand._source.network_group_id) === Number(this.selectedGroup));
    }
    if (this.selectedHomeTeam) {
      list = list.filter((brand: any) => (brand._source.home_team_id) === (this.selectedHomeTeam));
    }
    if (this.selectedAwayTeam) {
      list = list.filter((brand: any) => (brand._source.away_team_id) === (this.selectedAwayTeam));
    }
    if (this.selectedAthlete) {
      list = list.filter((brand: any) => (brand._source.athlete_id) === (this.selectedAthlete));
    }
    this.brandProductsList = list;
  }

  getFilterSearch() {
    let filterData = [];
    filterData.push(this.stockData);
    let Obj = { "name": 'category', "value": [] };
    this.categoryList.forEach(data => {
      if (data.fillter) {
        Obj.value.push(data.value);
      }
    })
    if (Obj.value && Obj.value.length > 0) {
      filterData.push(Obj);
    }
    if (this.filterArray.length > 0) {
      this.filterArray.forEach(data => {
        filterData.push(data);
      })
    }
    console.log(this.categoryList, this.selectedDiscount, "this.selectedDiscount0")
    if (this.selectedDiscount != '' && this.discountfilter.value != '') {
      console.log(this.selectedDiscount, "this.selectedDiscount1")
      filterData.push(this.discountfilter)
    }
    return filterData;

  }

  applyfilter(from?) {
    // this.sortData;
    if (from) {
      this.dumArray = [];
      this.sortData = {};
      this.range = {};
      this.selectedDiscount = '';
      this.overallFilter.forEach(fil => {
        fil.value.buckets.forEach(fildata => {
          fildata.fillter = false;
        });
      })

    }
    this.filterArray = this.dumArray;
    this.getFilterData();

  }

  sortData: any = {};
  sortName = "";
  sortbyfilter(data: any, sortName?) {
    this.sortName = sortName
    this.sortData = data;
    this.getFilterData('sort')
  }
  getstock() {
    if (this.stockData.value == 1) {
      this.stockData.value = 0;
      let element = document.getElementById('stockButton');
    }
    else {
      this.stockData.value = 1;
    }
    this.getFilterData('stock')
  }
  closeFilter() {
    $('#getingFilter').removeClass("show");
  }
  // Price Max and min
  mininput: any = '';
  maxinput: any = '';
  minerror: boolean = false;
  maxerror: boolean = false;
  minmessage = "";
  maxmessage = "";
  range: any = []
  priceValues(from?) {
    this.range = {};
    if (from == 'min') {
      if (this.mininput < Math.min.apply(null, this.price) && this.mininput != '') {
        this.minerror = true;
        this.minmessage = "Min value is " + Math.min.apply(null, this.price);
      }
      else if (this.mininput >= Math.max.apply(null, this.price) && this.mininput != '') {
        this.minerror = true;
        this.minmessage = "Min value cannot be greater or equal to " + Math.max.apply(null, this.price)
      }
      else {
        this.minerror = false;
        this.minmessage = "";
      }
    }
    if (from == 'max') {
      if (this.maxinput > Math.max.apply(null, this.price)) {
        this.maxerror = true;
        this.maxmessage = "Max value is " + Math.max.apply(null, this.price);
      }
      else if (this.maxinput < this.mininput && this.maxinput != '') {
        this.maxerror = true;
        this.maxmessage = "maxmimum value cannot be less than minimum value";
      }
      else {
        this.maxerror = false;
        this.maxmessage = '';
      }
    }
    let n = { "field": "price", "min": Number(this.mininput), "max": Number(this.maxinput) }
    if (this.mininput && this.maxinput && this.mininput <= this.maxinput && this.maxinput >= this.mininput) {
      this.range.push(n);
    }
    else {
      this.range = [];
    }
    if (from == 'price') {
      this.getFilterData("price");
    }
  }
  selectedDiscount: any = ''
  discountfilter = { name: 'discount', value: '' }
  disountFun(data) {
    if (data == '1') {
      if (this.selectedDiscount == '' || this.selectedDiscount == '0') {
        this.selectedDiscount = '1';
      }
      else {
        this.selectedDiscount = '';
      }
    }
    else if (data == '0') {
      if (this.selectedDiscount == '' || this.selectedDiscount == '1') {
        this.selectedDiscount = '0';
      }
      else {
        this.selectedDiscount = '';
      }
    }
    this.discountfilter.value = this.selectedDiscount;
    // if (this.selectedDiscount != '') {
    this.getFilterData('discount')
    // }
  }
  cleraFilter(data) {
    if (data == 'network') {
      // this.filterArray = [];
      // this.dumArray = [];
      this.overallFilter.forEach(fil => {
        this.filterArray = this.filterArray.filter(data => data.name != 'network');
        this.dumArray = this.filterArray.filter(data => data.name != 'network');
        console.log(fil, "fil")
        if (fil.name == 'network') {
          fil.value.buckets.forEach(fildata => {
            console.warn(fildata, "filldata")
            fildata.fillter = false;
          });
        }
      })
    }
    else if (data == 'discount') {
      // this.filterArray = [];
      // this.dumArray = [];
      this.overallFilter.forEach(fil => {
        this.filterArray = this.filterArray.filter(data => data.name != 'discount');
        this.dumArray = this.filterArray.filter(data => data.name != 'discount');
        console.log(fil, "fil")
        if (fil.name == 'discount') {
          fil.value.buckets.forEach(fildata => {
            console.warn(fildata, "filldata")
            fildata.fillter = false;
          });
        }
      })
    }
    else if (data == 'price') {
      this.range = [];
      this.mininput = '';
      this.maxinput = ''
    }
    else if (data == 'discount') {
      this.selectedDiscount = '';
      this.discountfilter.value = '';
    }
    this.getFilterData('clearfilter');

  }


  toggleTrue(id: number) {
    this.colors[id] = !this.colors[id];
  }
  public toggleButtonClass(name) {
    if (name) {
      this.isBlue = !this.isBlue;
    }
  }
  trackFinalSearch() {
    const cleanQuery = this.query?.trim();
    if (!cleanQuery) return;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Searched in Merchandise - "${this.query.trim()}" - ${userId}`);
    const data = {
      actionType: "product",
      metaData: {
        title: `Searched in Merchandise - "${this.query.trim()}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,
    }
    this.commanService.sendTriggeredEvent(data);
  }

  ngOnDestroy() {
    this.settingsDataSubscription?.unsubscribe();
    this.currencyInfoSubscription?.unsubscribe();
    this.performerInfoSubscription?.unsubscribe();
  }
}
